import React from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo'
import gql from 'graphql-tag'
import { SiteContainer, Flex } from 'core/layout';
import {
  ExpandLess,
  Copyright,
} from 'core/icons';
import { Feedback } from 'modules';
import { Logo, Hairline, Button } from 'elements';
import { ButtonStylerGrey } from 'elements/Button/styled';
import tulkojumi from 'utils/tulkojumi';
import pathWithRewrite from 'utils/pathWithRewrite';
import getHomeURL from 'utils/getHomeURL';
import InfoBlock from './components/InfoBlock';
import {
  StyledFooter,
  ScrollToTop,
  InfoContainer,
  BottomContainer,
  LogoGroup,
  SocialGroup,
} from './styled';

const QUERY = gql`
  query FooterMenuQuery($lang: String!) {
    teksti(lang: $lang, _id:[

      "vai_si_informacija_bija_noderiga",
      "ja_informacija_bija_noderiga",
      "ne_informacija_nebija_noderiga",
      "ja",
      "ne",
      "vai",
      "paldies_zina_sanemta",
      "ka_uzlabot_rakstu",
      "kadu_informaciju_meklejat",
      "raksts_nav_pareizs",
      "raksts_nav_saprotams",
      "man_nepatik_informacija",
      "cits",
      "izvelaties_iemeslu",
      "tava_zina",
      "noradiet_precizu_informaciju",
      "kluda",
      "nosutit",

      "lapas_sadalas",
      "lapas_sadalas",
      "noderigas_saites",
      "adrese",
      "darba_laiks",
      "liepajas_pilsetas_dome",
      "atpakal_uz_augsu"
    ]) {
      _id
      text
    }
    options(lang: $lang, _id: [
      "social",
      "footer_darba_laiks",
      "footer_adrese"
    ]) {
      _id
      data
    }
    menu(lang: $lang) {
      _id
      lang
      items {
        title
        path
        rewrite_url
        rewrite_source
        rewrite_target
      }
    }
  }
`
const queryOptions = {

  options: props => {
    let{ lang, postId, init_page, skip } = props
    return ({
      fetchPolicy: 'cache-first',
      skip: (skip || false),
      variables: {
        lang: (lang || 'lv')
      }
    })
  },
  props: props => {


    const {
    data: {
      loading,
      menu,
      teksti,
      options,
    }
    } = props;
    return {
      loading,
      menu,
      feedback:props.ownProps.feedback,
      lang:props.ownProps.lang,
      teksti,
      options,
    }
  }
}



var jump;
if (__isBrowser__) { // eslint-disable-line no-undef
  import('jump.js')
  .then((jumpModule) => {
    jump = jumpModule.default;
  })
}

class Footer extends React.PureComponent {
  // static contextTypes = {
  //   router: PropTypes.object,
  // };

  render() {
    // const { route } = this.context.router;
    const pathname = this.props.path;
    // const { location: { pathname }} = route;

    const askFeedback = this.props.feedback;
    // const askFeedback = pathname !== getHomeURL(this.props.lang);

    const {
      lang,
      loading,
      menu,
      teksti,
      options,
    } = this.props;

    if (loading) {
      return null;
    }

    // Menu
    const menu_primary = menu.filter(menu => menu._id === 'primary');
    const menu_scondary = menu.filter(menu => menu._id === 'scondary');
    const menu_noderigas_saites = menu.filter(menu => menu._id === 'noderibas-saites');
    const menu_lapas_sadalas = menu.filter(menu => menu._id === 'lapas-sadalas');

    let footer_data = [];
    const mapMenuItems = (menu, key) => {
      if (menu.length > 0) {
        const title = tulkojumi(teksti, key);
        const items = menu.map(mitem => (
          mitem.items.map(item => {
            const rewrite = pathWithRewrite(item);
            return ({
              label: item.title,
              link: rewrite.location,
              target: rewrite.target,
            });
          })
        ))[0];
        footer_data.push({
          title,
          items,
        });
      }
    }

    mapMenuItems(menu_lapas_sadalas, 'lapas_sadalas');
    mapMenuItems(menu_noderigas_saites, 'noderigas_saites');

    // Adrese
    const footer_adrese = options.find(option => option._id === 'footer_adrese');
    const option_footer_adrese = footer_adrese && JSON.parse(footer_adrese.data);
    if (option_footer_adrese && option_footer_adrese.length > 0) {
      footer_data.push({
        title: tulkojumi(teksti, 'adrese'),
        items: option_footer_adrese,
      });
    }

    const darba_laiks = options.find(option => option._id === 'footer_darba_laiks');
    const option_darba_laiks = darba_laiks && JSON.parse(darba_laiks.data);
    if (option_darba_laiks && option_darba_laiks.length > 0) {
      footer_data.push({
        title: tulkojumi(teksti, 'darba_laiks'),
        items: option_darba_laiks.map(item => ({
          content: item.column.split('|'),
        })),
      });
    }

    let social_data = [];
    const option_social_option = options.find(option => option._id === 'social');
    const option_social = option_social_option && JSON.parse(option_social_option.data);
    if (option_social && option_social.length > 0) {
      social_data = option_social.map(item => ({
        icon: item.icon,
        title: item.name,
        id: item.name.toLowerCase(),
        link: item.url
      }))
    }

    return menu && (
      <StyledFooter>
        <SiteContainer>
          {
            askFeedback && <Feedback lang={lang} teksti={teksti} path={pathname} />
          }

          <Flex justify='end' gutter={false}>
            <ScrollToTop>
              <ButtonStylerGrey>
                <Button
                  type='text'
                  icon={ExpandLess}
                  iconSize='large'
                  label={tulkojumi(teksti, 'atpakal_uz_augsu')}
                  onClick={() => {
                    jump && jump('#root', {
                      a11y: true,
                    });
                  }}
                />
              </ButtonStylerGrey>
            </ScrollToTop>
          </Flex>
        </SiteContainer>

        <Hairline />

        <SiteContainer>
          <InfoContainer>
            {
              footer_data.map(InfoBlock)
            }
          </InfoContainer>

          <Hairline />

          <BottomContainer>
            <LogoGroup>
              <Logo />
              <Copyright size='small' />
              {tulkojumi(teksti, 'liepajas_pilsetas_dome')}
            </LogoGroup>

            <SocialGroup>
              {
                social_data.map(item => (
                  <ButtonStylerGrey
                    key={item.id}
                  >
                    <Button
                      type='text'
                      icon={
                        require(`core/icons/components/social/${item.icon}`).default
                      }
                      title={item.title}
                      onClick={() => {
                        window.open(item.link)
                      }}
                    />
                  </ButtonStylerGrey>
                ))
              }
            </SocialGroup>
          </BottomContainer>

        </SiteContainer>
      </StyledFooter>
    );
  }
}

export default compose(
  graphql(QUERY, queryOptions)
)(Footer)



// WEBPACK FOOTER //
// ./src/modules/Footer/Footer.jsx